import { render, staticRenderFns } from "./DemoLicenses.vue?vue&type=template&id=1b75847e&scoped=true"
import script from "./DemoLicenses.vue?vue&type=script&lang=js"
export * from "./DemoLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75847e",
  null
  
)

export default component.exports